import { Box, Grid } from "@mui/material";
import ThemeContext from "components/app/Context";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";

import { fetchPlanDetailsAsync } from "components/features/PlanAssignment/PlanAssignment.slice";
import { DEFAULT_CORP_INNCODE, PAGE_SIZE } from "utils/CommonConstants";
import { getHoursAndMin } from "utils/CommonFunctions";
import Button from "../Button";
import CheckBox from "../Checkbox";
import FunctionalAreas from "../FunctionalAreas";
import PlanType from "../PlanType";
import TargetedPlanChip from "../TargetedPlanChip";
import Timing from "../Timing";
import Typography from "../Typography";
import "./PlanBar.scss";

interface Props {
  plan: any;
  checkedList: any;
  handleCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>, plan: any) => void;
  handleState: () => void;
  inncode: any;
}
function PlanBar(props: Props) {
  const { inncode, plan, checkedList, handleCheckboxChange, handleState } = props;
  const { isMobileScreen } = useContext(ThemeContext);
  const location = useLocation();
  const { isAbovePropertyUser }: any = useAppSelector((state) => state.app.loggedInUserDetails);
  const dispatch = useAppDispatch();

  const detailClickHandler = () => {
    dispatch(
      fetchPlanDetailsAsync({
        planId: plan?.id,
        innCode: inncode || DEFAULT_CORP_INNCODE,
        size: PAGE_SIZE
      })
    );
    handleState();
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        margin: "8px 0",
        alignItems: "center",
        border: isMobileScreen ? "" : `1px solid ${tokens.Border.General.Tertiary}`,
        borderBottom: isMobileScreen ? `1px solid ${tokens.Border.General.Tertiary}` : "",
        borderRadius: "8px",
        gap: "8px"
      }}
    >
      <Grid
        container
        sx={{
          alignItems: "flex-start",
          display: "flex",
          backgroundColor: tokens.Background.General.Primary,
          minheight: "76px",
          borderRadius: "8px",
          padding: "8px"
        }}
      >
        {isAbovePropertyUser && location?.pathname?.split("/")[1] === "userview" && plan?.planType ? (
          <Grid xs={12} md={12} marginBottom={"8px"}>
            <PlanType
              planType={plan?.planType}
              brandDeadlineDate={plan?.brandDeadlines?.[0]?.deadline}
              initiativeName={plan?.initiativeName}
            />
          </Grid>
        ) : (
          <></>
        )}

        <div className="full-width">
          <div className="plan-bar-section">
            <div className="top-section">
              <div className="name-wrapper">
                <CheckBox
                  className="plan-checkbox"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleCheckboxChange(e, plan)}
                  checked={checkedList?.findIndex((el: any) => el?.id === plan?.id) >= 0}
                />
                <Typography
                  component={"span"}
                  variant="body1"
                  showBold
                  color={tokens.Text.General.PrimaryHeadline}
                  className="ellipse-two"
                >
                  {plan?.name}
                </Typography>
              </div>
              <Typography component={"span"} color={tokens.Border.General.Secondary}>
                <Timing duration={getHoursAndMin(plan.timeEstimateMinutes)} />
              </Typography>
            </div>
            <div className="bottom-section">
              <div className="bottom-section_left">
                {plan.isTargeted && <TargetedPlanChip variant="horizontal" />}
                <div className="functional-area">
                  <FunctionalAreas functionalAreaIds={plan?.functionalAreaIds} showAbbrv={true} />
                </div>
              </div>
              <Button
                variant="outlined"
                className="view-details"
                label="View Details"
                size="Small"
                onClick={detailClickHandler}
              />
            </div>
          </div>
        </div>
      </Grid>
    </Box>
  );
}

export default PlanBar;
